import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { connect } from 'react-redux';
import { WindowSizePropType } from '../../../../CustomPropTypes/BrowserPropTypes';
import { PortalInstitutionPropType } from '../../../../CustomPropTypes/PortalPropTypes';
import {
  login,
  resetPassword,
  signUp,
} from '../../../../ReduxStorage/Auth/dispatchers';
import { LoginMode } from '../../../../ReduxStorage/Auth/Login/constants';
import { LoginSignup } from '../../../components/LoginSignup';
import { LoginForm } from '../../../components/LoginSignup/LoginForm';
import { SignUpForm } from '../../../components/LoginSignup/SignUpForm';
import { ResetPasswordForm } from '../../../components/LoginSignup/ResetPasswordForm';
import { PortalTopBar } from '../../PortalTopBar/PortalTopBar';
import { PortalFooter } from '../../PortalFooter/PortalFooter';
import { MIN_NAV_BAR_WINDOW_WIDTH } from '../../PortalShared';

class LoginPage extends React.PureComponent {
  static propTypes = {
    portalInstitution: PortalInstitutionPropType.isRequired,
    windowSize: WindowSizePropType.isRequired,
    onSignUp: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
    onResetPassword: PropTypes.func.isRequired,
  };

  // managing this via component state so as not to conflict with the LoginModal
  // which can exist on the same page
  state = {
    view: LoginMode.login,
  };

  onBackToLoginClick = () => {
    this.setState({ view: LoginMode.login });
  };

  onSelectLogin = () => {
    this.setState({ view: LoginMode.login });
  };

  onSelectSignup = () => {
    this.setState({ view: LoginMode.signup });
  };

  onForgotPassword = () => {
    this.setState({ view: LoginMode.forgotPassword });
  };

  onSignUp = (email, password, fullName, subscribe, recaptchaToken) => {
    const { portalInstitution, onSignUp } = this.props;

    let managedByInstitution = null;
    if (portalInstitution && portalInstitution.get('autoAddNewUsersToPortal')) {
      managedByInstitution = portalInstitution.get('name');
    }

    return onSignUp(
      email,
      password,
      fullName,
      subscribe,
      managedByInstitution,
      false,
      recaptchaToken
    );
  };

  render() {
    const { view } = this.state;
    const {
      portalInstitution,
      windowSize,
      onLogin,
      onResetPassword,
    } = this.props;

    const showMobileNavBar =
      windowSize && windowSize.outerWidth < MIN_NAV_BAR_WINDOW_WIDTH;

    const backgroundColor = portalInstitution.getIn([
      'themeData',
      'brand-color-dark',
    ]);

    return (
      <div className="portal-institution-page" css={css({ backgroundColor })}>
        <PortalTopBar {...{ portalInstitution, showMobileNavBar }} pageReady />
        <div className="portal-body">
          <h3 css={css({ color: 'white', fontWeight: 'normal' })}>
            Log in to {portalInstitution.get('institutionName')}
          </h3>
          <LoginSignup
            onBackToLoginClick={this.onBackToLoginClick}
            onSelectLogin={this.onSelectLogin}
            onSelectSignup={this.onSelectSignup}
            view={view}
            loginForm={
              <LoginForm
                onForgotPassword={this.onForgotPassword}
                onLogin={onLogin}
              />
            }
            signUpForm={<SignUpForm onSignUp={this.onSignUp} />}
            resetPasswordForm={
              <ResetPasswordForm onResetPassword={onResetPassword} />
            }
          />
        </div>
        <PortalFooter footerData={portalInstitution.get('footer')} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLogin: (email, password) =>
      dispatch(login(email, password)).then(() => window.location.reload()),
    onResetPassword: (email) => dispatch(resetPassword(email)),
    onSignUp: (
      email,
      password,
      fullName,
      subscribe,
      managedByInstitution,
      sso,
      recaptchaToken
    ) =>
      dispatch(
        signUp(
          email,
          password,
          fullName,
          subscribe,
          managedByInstitution,
          sso,
          recaptchaToken
        )
      )
        .then(() => dispatch(login(email, password)))
        .then(() => window.location.reload()),
  };
};

export const ConnectedLoginPage = connect(null, mapDispatchToProps)(LoginPage);
